import computedStyleToInlineStyle from "computed-style-to-inline-style";

function getDataAsBlob(data, dataType) {
  const blob = new Blob([data], { type: dataType });
  return blob;
}

function openBlobAsNewTab(blob) {
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
}

function downloadBlob(blob, filename) {
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    let link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        // delay removal to be working in firefox
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } else {
      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        // delay removal to be working in firefox
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
  }
}

function csvDownload(data, fields, filename) {
  return import("@json2csv/plainjs")
    .then(({ Parser }) => {
      const parser = new Parser({ fields });
      return parser.parse(data);
    })
    .then(csv => {
      let blob = getDataAsBlob(csv, "text/csv;charset=utf-8;");
      downloadBlob(blob, filename);
    });
}

function imageDownload(ref, name) {
  const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
  window.scrollTo(0, 0);
  const filename = name ? `${name}.png` : "chart.png";
  const scale = 2;
  const { offsetWidth: width, offsetHeight: height } = ref;
  computedStyleToInlineStyle(ref, {
    recursive: true,
    properties: ["font-size", "stroke", "fill"]
  });
  return import("html2canvas").then(({ default: html2canvas }) =>
    html2canvas(ref, { scale, width, height }).then(canvas =>
      canvas.toBlob(png => {
        let blob = getDataAsBlob(png, "image/png");
        downloadBlob(blob, filename);
        window.scrollTo(0, scrollTop);
      })
    )
  );
}

export { getDataAsBlob, openBlobAsNewTab, downloadBlob, csvDownload, imageDownload };
